export default "__VITE_ASSET__B1T9IFo7__"